import { LucideIcon } from "lucide-react";

interface CardProps {
  title: string;
  value: number;
  icon: LucideIcon;
  iconColor: string;
}

const Card: React.FC<CardProps> = ({ title, value, icon: Icon, iconColor }) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-lg transition-shadow duration-200">
      <div className="flex flex-row items-center justify-between space-y-0 pb-2 p-6">
        <h3 className="text-sm font-medium text-gray-600">{title}</h3>
        <Icon className={`h-5 w-5 ${iconColor}`} />
      </div>
      <div className="px-6 pb-6">
        <div className="text-3xl font-bold text-gray-900">{value}</div>
      </div>
    </div>
  );
};

export default Card;
